import {
  Card,
  Grid,
  IconEdit,
  IconLogoPowerpoint,
  IconRobot,
  spacing,
  styled,
  TextElement,
  useTranslation,
} from '@lessonup/ui-components';
import React, { useState } from 'react';
import { TRANSLATION_NAMESPACE } from '../constantsV2';
import { Footer } from './Footer';
import { LessonModalMainWrapper } from './LayoutComponents';

interface ChooseEditorProps {
  onSelect: (editor: 'ai' | 'lesson' | 'sdi') => void;
  back: () => void;
}

export const ChooseNewEditorMode: React.FC<ChooseEditorProps> = ({ onSelect, back }) => {
  const [selectedEditorMode, setSelectedEditorMode] = useState<'ai' | 'lesson' | 'sdi'>();
  const { t } = useTranslation(TRANSLATION_NAMESPACE, { keyPrefix: 'chooseNewEditorMode' });

  return (
    <LessonModalMainWrapper>
      <StyledGrid cols={2} gap={spacing.size16}>
        <StyledCard
          resizing="fixed"
          active={selectedEditorMode === 'lesson'}
          onClick={() => setSelectedEditorMode('lesson')}
        >
          <StyledText>
            <TextElement
              textStyle="bodyText"
              as="h2"
              size="small"
              weight="bold"
              style={{ display: 'flex', alignItems: 'flex-start', gap: spacing.size8 }}
            >
              <IconEdit />
              {t('fromScratchTitle')}
            </TextElement>
            <TextElement textStyle="bodyText" size="small">
              {t('fromScratchDescription')}
            </TextElement>
          </StyledText>
        </StyledCard>
        <StyledCard resizing="fixed" active={selectedEditorMode === 'sdi'} onClick={() => setSelectedEditorMode('sdi')}>
          <StyledText>
            <TextElement
              textStyle="bodyText"
              as="h2"
              size="small"
              weight="bold"
              style={{ display: 'flex', alignItems: 'flex-start', gap: spacing.size8 }}
            >
              <IconLogoPowerpoint />
              {t('sdiTitle')}
            </TextElement>
            <TextElement textStyle="bodyText" size="small">
              {t('sdiDescription')}
            </TextElement>
          </StyledText>
        </StyledCard>
        <StyledCard resizing="fixed" active={selectedEditorMode === 'ai'} onClick={() => setSelectedEditorMode('ai')}>
          <StyledText>
            <TextElement
              textStyle="bodyText"
              size="small"
              weight="bold"
              style={{ display: 'flex', alignItems: 'flex-start', gap: spacing.size8 }}
            >
              <IconRobot />
              {t('aiTitle')}
            </TextElement>
            <TextElement textStyle="bodyText" size="small">
              {t('aiDescription')}
            </TextElement>
          </StyledText>
        </StyledCard>
      </StyledGrid>
      <Footer
        backButton={{ onClick: back, label: t('back') }}
        nextButton={{
          onClick: () => selectedEditorMode && onSelect(selectedEditorMode),
          label: t('continue'),
          disabled: !selectedEditorMode,
        }}
      />
    </LessonModalMainWrapper>
  );
};

const StyledCard = styled(Card)`
  overflow: hidden;
`;

const StyledGrid = styled(Grid)`
  margin: ${spacing.size16};
  height: 100%;
`;

const StyledText = styled.div`
  height: 100%;
  padding: ${spacing.size8};
`;
